export class RitzComponentsCollection {
    private static instance: RitzComponentsCollection;

    private collection: Map<string, React.FC>;

    // Private because it is a singleton
    // eslint-disable-next-line no-useless-constructor
    private constructor () {
        this.collection = new Map<string, React.FC>();
    }


    public static getInstance (): RitzComponentsCollection {
        if (!RitzComponentsCollection.instance) {
            RitzComponentsCollection.instance = new RitzComponentsCollection();
        }
        return RitzComponentsCollection.instance;
    }


    public registerComponent (name: string, component: React.FC<any>) {
        if (this.collection.has(name)) {
            throw new Error(`Component name '${name}' already exists`);
        }
        this.collection.set(name, component);
    }

    public getComponent (name: string): React.FC<any> | undefined {
        return this.collection.get(name);
    }
}
